<template>
  <div class="carousel-container" @mouseenter="pause" @mouseleave="play">
    <div
      class="carousel-track"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <!-- 无缝衔接：前后各复制一张 -->
      <img :src="images[images.length - 1]" alt="carousel-img" class="carousel-item" @error="handleImgError"/>
      
      <!-- 真实的图片列表 -->
      <img
        v-for="(image, index) in images"
        :key="index"
        :src="image"
        alt="carousel-img"
        class="carousel-item"
		@error="handleImgError"
      />
      
      <!-- 无缝衔接：前后各复制一张 -->
      <img :src="images[0]" alt="carousel-img" class="carousel-item" @error="handleImgError"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  // 1. 使用 props 选项来定义属性
  props: {
    images: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      default: 3000,
    },
  },
  // 2. 使用 data 选项来定义响应式状态
  data() {
    return {
      currentIndex: 1, // 初始索引为 1，对应第一张真实图片
      timer: null,
	  defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
    };
  },
  // 3. 使用 methods 选项来定义方法
  methods: {
	handleImgError(e) {
	    // e.target 指向加载失败的 img 元素，替换其 src 为默认图片
	    e.target.src = this.defaultGoodsImg;
	    // 可选：防止默认图片也加载失败时无限触发 onerror 事件
	    e.target.onerror = null;
	},
    play() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.next();
      }, this.interval);
    },
    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      this.currentIndex++;

      // 无缝衔接的核心逻辑
      if (this.currentIndex === this.images.length + 1) {
        // 等待当前的过渡动画结束
        setTimeout(() => {
          // 关闭过渡效果，瞬间跳转到真实的第一张图
          this.$el.querySelector('.carousel-track').style.transition = 'none';
          this.currentIndex = 1;
          
          // 在下一帧重新开启过渡效果
          this.$nextTick(() => {
            this.$el.querySelector('.carousel-track').style.transition = 'transform 0.5s ease';
          });
        }, 500); // 这个时间应与 CSS 中的 transition-duration 保持一致
      }
    },
  },
  // 4. 使用生命周期钩子
  mounted() {
    this.play();
  },
  beforeDestroy() { // Vue 2
  // beforeUnmount() { // Vue 3
    this.pause();
  },
};
</script>

<style scoped>
/* 样式部分保持不变 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.carousel-item {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// carousel.vue?5714982d